import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { Dialog, Button, Input, AutoComplete, Icon } from '@tencent/spaui';
import { RPCFactory } from '../../../../utils/RequestUtil';

export const LabelGroups = (props) => {
  const [groupList, setGroupList] = useState([]);
  const [searchedGroupList, setSearchedGroupList] = useState([]);
  const [showDialog, setShowDialog] = useState(false);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [editItem, setEditItem] = useState({});
  const [type, setType] = useState('add');
  const [dragItem, setDragItem] = useState(-1);
  const [searchedStrForGroup, setSearchedStrForGroup] = useState('');
  const isEditable = window.pageProps.privileges.indexOf('TAG_MANAGE') !== -1;

  const onConfirmDelete = () => {
    _.remove(groupList, (item) => item.tagGroupId === editItem.tagGroupId);
    const newGroupList = [...groupList];
    setGroupList(newGroupList);
    setSearchedGroupList(newGroupList);
    setShowDeleteDialog(false);
    props.setGroupNum(newGroupList.length);
    if (editItem.tagGroupId === props.tagGroupId) {
      props.setGroupId(newGroupList.length ? newGroupList[0].tagGroupId : null);
    }
    const tagNum = newGroupList.reduce((total, item) => total + (item.tagCount || 0), 0);
    props.setTagNum(tagNum);
    RPCFactory.labelGroupManage
      .deleteGroup({ tagGroupId: editItem.tagGroupId })
      .done((data) => {
        console.log(`${editItem.tagGroupId  } deleted`);
      })
      .fail((ret, msg) => {
        window.alert(`操作失败,${msg}`);
      });
  };

  useEffect(() => {
    setGroupList(props.groupList);
    setSearchedGroupList(props.groupList);
    props.setGroupId(props.tagGroupId || (props.groupList.length > 0 ? props.groupList[0].tagGroupId : ''));
    props.setGroupNum(props.groupList.length);
    const tagNum = props.groupList.reduce((total, item) => total + (item.tagCount || 0), 0);
    props.setTagNum(tagNum);
  }, [props.groupList]);

  const changeLabelGroup = () => {
    if (!editItem.tagGroupName) {
      return alert('请填选内容');
    }
    setShowDialog(false);
    let newGroupList = [];
    if (type === 'add') {
      RPCFactory.labelGroupManage
        .addGroup({ tagGroupName: editItem.tagGroupName })
        .done((data) => {
          props.setGroupId(data.tagGroupId);
          newGroupList = [
            ...groupList,
            {
              tagGroupName: editItem.tagGroupName,
              tagGroupId: data.tagGroupId,
              customizedTagGroup: true,
            },
          ];
          setGroupList(newGroupList);
          setSearchedGroupList(newGroupList);
          props.setGroupNum(newGroupList.length);
          const tagNum = newGroupList.reduce((total, item) => total + (item.tagCount || 0), 0);
          props.setTagNum(tagNum);
        })
        .fail((ret, msg) => {
          window.alert(`操作失败,${msg}`);
        });
    } else {
      RPCFactory.labelGroupManage
        .updateGroup({
          tagGroupName: editItem.tagGroupName,
          tagGroupId: editItem.tagGroupId,
        })
        .done((data) => {
          const index = _.findIndex(groupList, (item) => item.tagGroupId === editItem.tagGroupId);
          newGroupList = [...groupList];
          newGroupList[index].tagGroupName = editItem.tagGroupName;
          props.setGroupId(editItem.tagGroupId);
          setGroupList(newGroupList);
          setSearchedGroupList(newGroupList);
          props.setGroupNum(newGroupList.length);
          const tagNum = newGroupList.reduce((total, item) => total + (item.tagCount || 0), 0);
          props.setTagNum(tagNum);
        })
        .fail((ret, msg) => {
          window.alert(`操作失败,${msg}`);
        });
    }
  };
  const onClickEdit = (item) => {
    setEditItem(item);
    setType('edit');
    setShowDialog(true);
  };
  const onClickDelete = (item) => {
    setEditItem(item);
    setType('delete');
    setShowDeleteDialog(true);
  };
  const onClickGroup = (item) => {
    props.setGroupId(item.tagGroupId);
  };
  const handleDrop = (e, index, isLast) => {
    if (isLast) return;
    const dataList = _.cloneDeep(groupList);
    dataList[index] = groupList[dragItem];
    dataList[dragItem] = groupList[index];
    setGroupList(dataList);
    setSearchedGroupList(dataList);
  };
  const handleSearchTextChange = (event, value) => {
    setSearchedStrForGroup(value);
  };
  const onClickSearchIcon = () => {
    const searchResult = _.filter(groupList, (item) => item.tagGroupName.indexOf(searchedStrForGroup) !== -1);
    setSearchedGroupList(searchResult);
  };
  const handleKeyPress = (event, value) => {
    if (event.charCode == 13) {
      const searchResult = _.filter(groupList, (item) => item.tagGroupName.indexOf(searchedStrForGroup) !== -1);
      setSearchedGroupList(searchResult);
    }
  };
  return (
    <div className="label-group-container">
      <div className="search-and-create">
        <Button
          className="add-item-btn"
          displayType="primary"
          size="small"
          disabled={!isEditable}
          onClick={() => {
            setShowDialog(true);
            setType('add');
            setEditItem({});
          }}
        >
          +新建分组
        </Button>
        <AutoComplete
          value={searchedStrForGroup}
          onChange={handleSearchTextChange}
          open={false}
          onClickSearchIcon={onClickSearchIcon}
          onKeyPress={handleKeyPress}
          placeholder="请输入分组名称"
        />
      </div>
      <div className="label-group-items">
        <div className="label-group-prompt">提示：拖拽分组可上下调整顺序</div>
        <ul>
          {searchedGroupList.map((item, index) => (
            <li
              key={index}
              className={`label-group-box${item.tagGroupId === props.tagGroupId ? ' active' : ''}`}
              draggable={true}
              onDragStart={() => {
                setDragItem(index);
              }}
              onDrop={(event) => handleDrop(event, index)}
              onDragOver={(e) => {
                e.preventDefault();
              }}
              onClick={() => onClickGroup(item)}
            >
              <div className="label-group-div">
                <div className="label-group-name-and-count">
                  <div className="label-group-name">{item.tagGroupName}</div>
                  <div className="label-group-count">{item.tagCount || 0}个标签</div>
                </div>
                <span className="spaui-menuitem-action">
                  {isEditable && item.customizedTagGroup && (
                    <a
                      href="javascript:void(0)"
                      aria-label="编辑"
                      onClick={(e) => {
                        onClickEdit(item);
                      }}
                      className="editable-icon"
                    >
                      <i className="icon icon-pen"></i>
                    </a>
                  )}
                  {isEditable && item.customizedTagGroup && (
                    <a
                      href="javascript:void(0)"
                      aria-label="删除"
                      onClick={(e) => {
                        onClickDelete(item);
                      }}
                      className="delete-icon"
                    >
                      <i className="icon icon-delete"></i>
                    </a>
                  )}
                </span>
              </div>
              <div className="group-arrow">
                <Icon name="triangle-right-outlined" width="20" height="20" color="#296BEF" />
              </div>
            </li>
          ))}
        </ul>
      </div>
      <Dialog
        backdrop
        show={showDialog}
        onClose={() => {
          setShowDialog(false);
        }}
        onCancel={() => {
          setShowDialog(false);
        }}
        onSubmit={changeLabelGroup}
        style={{ width: '360px', height: '240px' }}
        type="normal"
        title={type == 'add' ? '新增分组' : '编辑分组'}
        className="modal-add-new"
      >
        <div className="message-setting form-list-normal" style={{ marginTop: '25px' }}>
          <ul className="infos">
            <li className="edit-item">
              <span className="info-tt">分组名称</span>
              <div className="info-des">
                <Input
                  placeholder="请输入分组名称, 最多10个字"
                  maxLength="10"
                  value={editItem.tagGroupName}
                  onChange={(event, value) => {
                    setEditItem(_.defaults({ tagGroupName: value }, editItem));
                  }}
                />
              </div>
            </li>
          </ul>
        </div>
      </Dialog>
      <Dialog
        show={showDeleteDialog}
        style={{ width: '360px', height: '240px' }}
        onCancel={() => {
          setShowDeleteDialog(false);
        }}
        onSubmit={onConfirmDelete}
        onClose={() => {
          setShowDeleteDialog(false);
        }}
        type="normal"
        width={'280px'}
        eventTargetPlacement={'bottom'}
        title={'删除分组'}
        className="modal-delete"
      >
        <div className="confirmbox confirmbox-del">
          <div className="content">
            <p className="tt">
              如果当前分组下有标签，确认删除该分组，相关标签也会被删除，但已使用标签的线索／会话／粉丝不会删除该标签。
            </p>
          </div>
        </div>
      </Dialog>
    </div>
  );
};
